import {LocalStorageKey, getFromLocalStorage, setInLocalStorage} from "../localStorage";

export const getClosedDynamicBannerList = () =>
  getFromLocalStorage(LocalStorageKey.DynamicBannersClosed) || [];

export const addToClosedDynamicBannerList = (id: string) => {
  setInLocalStorage(LocalStorageKey.DynamicBannersClosed, [...getClosedDynamicBannerList(), id]);
};
